module.exports = __webpack_public_path__ + "static/media/Home Page  HV.7a150c43.png";